import { Button } from 'components/uikit/Button'

interface Props {
  image: string
  alt: string
  title: string
  description: string
  buttonText: string
  className?: string
  url?: string
  onButtonClick?: () => void
}

export const HelpCard = ({ image, alt, title, description, buttonText, className, url, onButtonClick }: Props) => {
  const handleButtonClick = () => {
    onButtonClick && onButtonClick()
    window.location.href = url || '/'
  }
  return (
    <div className={`${className} flex gap-x-[22px]`}>
      <div className="max-w-20 max-h-20">
        <img src={image} alt={alt} />
      </div>
      <div className="flex flex-col gap-y-4">
        <h3 className="text-white text-[28px] leading-[40px] font-semibold">{title}</h3>
        <p className="text-white">{description}</p>
        <Button
          className="mt-auto border-none"
          size="fit"
          variant="secondary"
          onClick={handleButtonClick}
          text={buttonText}
        />
      </div>
    </div>
  )
}
